<template>
  <form novalidate @submit.prevent="requestResetPassword">
    <b-form-group label="Email" label-for="inputTextEmail">
      <b-form-input
        id="inputTextEmail"
        v-model="form.email"
        type="text"
        autocomplete="username"
        placeholder="Enter email"
        :class="errors.email || $v.form.email.$error ? 'is-invalid' : ''"
      ></b-form-input>
      <b-form-invalid-feedback v-if="errors.email">
        {{ errors.email }}
      </b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="!$v.form.email.required">
        Can not be empty
      </b-form-invalid-feedback>
    </b-form-group>

    <button class="submit-btn" type="submit" :disabled="isSubmit">
      {{ isSubmit ? 'Sending…' : 'Send reset link' }}
    </button>

    <p v-if="formError" class="form-status" data-tone="error" role="status" aria-live="polite">
      {{ formError }}
    </p>
  </form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import axios from 'axios';
import { bodyStatusError, requestErrorMessage } from '@/util/master/requestError';

const FALLBACK_ERROR = 'Failed to request reset password. Please try again later.';

export default {
  name: 'ForgotPasswordForm',
  mixins: [validationMixin],
  data() {
    return {
      errors: {},
      formError: '',
      form: {
        email: undefined,
      },
      isSubmit: false,
    };
  },
  validations: {
    form: {
      email: {
        required,
      },
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'form.email': function () {
      this.$v.form.email.$touch();
    },
  },
  methods: {
    async requestResetPassword() {
      this.resetError();
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;

      this.isSubmit = true;
      try {
        const res = await axios.post('/api/account/reset_password/request', {
          email: this.form.email,
        });
        // gagalnya dateng HTTP 200, jadi statusnya dibaca dari body
        const failed = bodyStatusError(res.data);
        if (failed) {
          this.fail(failed.message);
          return;
        }
        this.$emit('onSuccess');
      } catch (err) {
        this.fail(requestErrorMessage(err, FALLBACK_ERROR));
      } finally {
        this.isSubmit = false;
      }
    },
    fail(message) {
      this.formError = message;
      this.$emit('onFailure', message);
    },
    resetError() {
      this.errors = {};
      this.formError = '';
    },
  },
};
</script>
